import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';

interface typesOfActiveStaffList {
    details: any;
    loading: boolean;
    error: string | null | boolean;
}
const initialState: typesOfActiveStaffList = {
    details: {},
    loading: false,
    error: null,
};

export const fetchStaffDetails = createAsyncThunk('staffDetail/fetchStaffDetails', async ({ username }: { username: string }) => {
    const response: any = await client.get('/user/getUser', {
        headers: {
            username,
        },
    });
    const { msg, statusCode, code, ...staffDetails } = response;
    return staffDetails || {};
});

const staffDetailsSlice = createSlice({
    name: 'staffDetail',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchStaffDetails.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchStaffDetails.fulfilled, (state, action) => {
            state.loading = false;
            if (!action.payload) return;
            state.details = action.payload || {};
        });
        builder.addCase(fetchStaffDetails.rejected, (state) => {
            state.loading = false;
            state.error = true;
        });
    },
});

export default staffDetailsSlice.reducer;
